module.exports = __webpack_public_path__ + "static/media/x-line-safes.2d90aa47.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/model-serial-number/x-line-safes.png
// module id = 1303
// module chunks = 0